// extracted by css-extract-rspack-plugin
export default {"emptyState":"DCPH1Riu9mcpzHw1","emptyStateHeader":"CEM45CQftE8kNCU4","emptyStateMessage":"XX8PKBuYI6LM5ouW"};